export default __webpack_public_path__ + "static/sample4-18c58669703b93e5e69a9e08e0dca030.webp";